export const removeErrorOnChange = (errors: any, name: string) => {
  const error = { ...errors };
  if (error[name]) {
    delete error[name];
  }
  return error;
};
